import { Component, forwardRef, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxLinkComponent } from '@onyx/angular';
import { RoutePointComponent } from '../../../../../../../../../common/components/route/route-point/route-point.component';
import { RouteHelper } from '../../../../../../../../../common/helpers/route.helper';
import type { TelematicsRoutePoint } from '../../../../../../../../../common/interfaces/telematics/telematics-route-point';
import { OrderHelper } from '../../../../../../../../orders/common/helpers/order.helper';
import type { SwapUnassignPointReason } from '../../../../../../enums/swap/swap-unassign-point-reason';

@Component({
  selector: 'app-swap-modal-summary-item-unassigned-points-group',
  imports: [
    TranslatePipe,
    forwardRef(() => RoutePointComponent),
    OnyxLinkComponent,
  ],
  templateUrl:
    './swap-modal-summary-item-unassigned-points-group.component.html',
  styleUrl: './swap-modal-summary-item-unassigned-points-group.component.scss',
})
export class SwapModalSummaryItemUnassignedPointsGroupComponent {
  private readonly orderHelper = inject(OrderHelper);

  public readonly reason = input.required<SwapUnassignPointReason>();
  public readonly points = input.required<TelematicsRoutePoint[]>();
  public readonly translateKey = input.required<string>();
  public readonly identifierColor = input.required<OnyxColor | null>();

  protected readonly I18N = 'map.swapPanel';

  protected isFirstPointOfOrder(
    points: TelematicsRoutePoint[],
    item: TelematicsRoutePoint,
    index: number,
  ): boolean {
    if (!item.order?.isDedicated) return true;

    const previousPoint = points.slice(0, index).findLast(Boolean);
    return !previousPoint || previousPoint.order?.uuid !== item.order?.uuid;
  }

  protected getIsDedicatedPointClass(
    points: TelematicsRoutePoint[],
    item: TelematicsRoutePoint,
    index: number,
  ): string {
    if (!item.order?.isDedicated) return '';

    const previousPoint = points.slice(0, index).findLast(Boolean);
    const nextPoint = points.slice(index + 1).find(Boolean);

    const orderUuid = item.order?.uuid;
    const isFirst = !previousPoint || previousPoint?.order?.uuid !== orderUuid;
    const isLast = !nextPoint || nextPoint?.order?.uuid !== orderUuid;

    if (isFirst && isLast) return 'ftl-single';
    if (isFirst) return 'ftl-first';
    if (isLast) return 'ftl-last';

    return 'ftl-middle';
  }

  protected getOrderLabel(item: TelematicsRoutePoint): {
    type: string;
    identifier: string;
  } {
    const order = item.order;
    if (!order) return { type: '', identifier: '' };

    return {
      type: RouteHelper.isOrderDedicated(order) ? 'FTL' : 'LTL',
      identifier: order.identifier,
    };
  }

  protected openOrderModal(uuid: string | null): void {
    if (uuid) this.orderHelper.openModal(uuid);
  }
}
